import {
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useMemo, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./style.css";
import { useEffect } from "react";
import bag_grey from "../../images/new_bag.png";
import buy from "../../images/buy.png";
import bag from "../../images/colorbag.png";
import home_g from "../../images/home_g.png";
import home_q_grey from "../../images/home_q_grey.png";
import sell1 from "../../images/newsell.png";
import Chart from "../../images/chartgrey.png";
import ChartGreen from "../../images/chart_grey.png";

function Index() {

    const location = useLocation();

    const validPaths = ["feeds", "buysell", "charts", "portfolio", "leaderboard","create-feed","profile","chatHistory"];

    // Extract the first segment (slug) and the second segment of the path
    const pathSegments = location.pathname.split("/");

    // The first segment is the slug (e.g., "new")
    const slug = pathSegments[1];

    // The second segment is the valid path (e.g., "buysell")
    const pathSegment = pathSegments[2];

    // Check if the second segment matches any of the valid paths
    const isValidPath = validPaths.includes(pathSegment);

    // Alert the slug and whether the path is valid



  // const menus = useMemo(
  //   () => [
  //     {
  //       label: "Feed",
  //       icon: home_q_grey,
  //       activeIcons: home_g,
  //       link: "/feed",
  //       dis: "translate-x-0",
  //     },
  //     {
  //       label: "Search",
  //       icon: bag_grey,
  //       activeIcons: bag,
  //       link: "/portfolio",
  //       dis: "translate-x-16",
  //     },
  //     {
  //       label: "Add",
  //       icon: faPlus,
  //       link: "/create-post",
  //       dis: "translate-x-32",
  //     },
  //     {
  //       label: "Buy Sell",
  //       icon: buy,
  //       activeIcons: sell1,
  //       link: "/buysell",
  //       dis: "translate-x-48",
  //     },
  //     {
  //       label: "Chart",
  //       icon: Chart,
  //       activeIcons: ChartGreen,
  //       link: "/charts",
  //       dis: "translate-x-64",
  //     },
  //   ],
  //   []
  // );


  const menus = useMemo(
  () => {
    if (isValidPath) {
      // Define menus for valid paths
      return [
{
        label: "Feed",
        icon: home_q_grey,
        activeIcons: home_g,
        link: `/${slug}/feeds`,
        dis: "translate-x-0",
      },
      {
        label: "Search",
        icon: bag_grey,
        activeIcons: bag,
        link: `/${slug}/portfolio`,
        dis: "translate-x-16",
      },
      {
        label: "Add",
        icon: faPlus,
        link: `/${slug}/create-feed`,
        dis: "translate-x-32",
      },
      {
        label: "Buy Sell",
        icon: buy,
        activeIcons: sell1,
        link: `/${slug}/buysell`,
        dis: "translate-x-48",
      },
      {
        label: "Chart",
        icon: Chart,
        activeIcons: ChartGreen,
        link: `/${slug}/charts`,
        dis: "translate-x-64",
      },
      ];
    } else {
      // Define menus for invalid paths or default paths
      return [
    {
        label: "Feed",
        icon: home_q_grey,
        activeIcons: home_g,
        link: "/feed",
        dis: "translate-x-0",
      },
      {
        label: "Search",
        icon: bag_grey,
        activeIcons: bag,
        link: "/portfolio",
        dis: "translate-x-16",
      },
      {
        label: "Add",
        icon: faPlus,
        link: "/create-post",
        dis: "translate-x-32",
      },
      {
        label: "Buy Sell",
        icon: buy,
        activeIcons: sell1,
        link: "/buysell",
        dis: "translate-x-48",
      },
      {
        label: "Chart",
        icon: Chart,
        activeIcons: ChartGreen,
        link: "/charts",
        dis: "translate-x-64",
      },
      ];
    }
  },
  [isValidPath] // Dependency to re-run memo when isValidPath changes
);

  const { pathname } = useLocation();

  const [active, setActive] = useState(
    menus.findIndex((x) => x.link === pathname)
  );

  useEffect(() => {
    setActive(menus.findIndex((x) => x.link === pathname));
  }, [pathname, menus]);

  if (
    pathname === "/chatHistory" ||
    pathname === "/chat" ||
    pathname === "/notifications"
  ) {
    return null;
  }

  return (
    <>
      <div
        className="md:hidden flex justify-center fixed bottom-0 w-full bg-white left-0 z-20 h-16"
      >
        {" "}
        <div className="flex gap-4 text-gray-600 relative">
          {menus[active] && (
            <span
              className={`h-16 w-16 absolute -top-5 rounded-full duration-500 ${menus[active]?.dis}`}
            ></span>
          )}
          {menus.map((menu, index) => (
            <NavLink
              key={index}
              to={menu.link}
              onClick={() => setActive(index)}
              className="buttonNavbarBottom"
            >
              <span
                className={
                  index === 2
                    ? `mt-2 text-xl z-20 duration-500 ${"text-white"}`
                    : `text-xl z-20 ${index === active && " text-white"}`
                }
              >
                {index === active && index !== 2 ? (
                  <img className={index == 4 ? "text-gray h-[48px]" :"text-gray   h-8"} src={menu?.activeIcons} />
                ) :  index !== active && index !== 2 ? (
                  <img className={index == 4 ? "text-gray h-[48px]" : "text-gray   h-8"} src={menu?.icon} />
                ) : (
                  <FontAwesomeIcon
                    className={`${index === 2 && "bg-primaryColor w-8 h-8 rounded-full p-1"
                      }`}
                    icon={menu.icon}
                  />
                )}
              </span>
              {/* <span
              className={`text-xs font-semibold ${
                active === index
                  ? " text-green-500 translate-y-2 duration-500 opacity-100"
                  : "text-gray opacity-100  duration-500 translate-y-2"
              }`}
            >
              {index === 2 ? "" : menu.label}
            </span> */}
            </NavLink>
          ))}
        </div>
      </div>
    </>
  );
}

export default Index;
